module.exports = __webpack_public_path__ + "img/napszemcsi.c94aa092.png";